export default {
    api: 'http://localhost:3011',
};
